import { Fragment } from "react";
import { matchPath, useLocation } from "react-router-dom";

import { v4 as uuidv4 } from "uuid";

import { Box, Divider, List, styled } from "@mui/material";

import useAuth from "src/hooks/useAuth";

import SidebarMenuItem from "./item";
import menuItems from "./items";

const DividerWrapper = styled(Divider)(
  ({ theme }) => `
  background: ${theme.sidebar.menuItemIconColor};
  margin-left: ${theme.spacing(3)};
  margin-right: ${theme.spacing(3)};
  opacity: .25;
`,
);

const MenuWrapper = styled(Box)(
  ({ theme }) => `

  &:last-of-type + .MuiDivider-root {
      height: 0;
  }

  .MuiList-root {
     display:flex;
     flex-direction:column;
     gap:4px;
    padding: ${theme.spacing(1, 0)};
    .MuiDivider-root {
      background: ${theme.sidebar.menuItemIconColor};
      margin-left: ${theme.spacing(3)};
      margin-right: ${theme.spacing(3)};
    }

    & > .MuiList-root {
      padding: 0;
   
    }
  }
`,
);

const SubMenuWrapper = styled(Box)(
  ({ theme }) => `
    .MuiList-root {
      padding: 0;
        
      .MuiList-root .MuiList-root .MuiListItem-root .MuiIconButton-root {
        font-weight: normal !important;
    
      }

      .MuiListItem-root {
        padding: 0px 10px;
        justify-content: flex-start;
  
        .MuiIconButton-root {
          display: flex;
          color: ${theme.sidebar.menuItemColor};
          background-color: ${theme.sidebar.menuItemBg};
          width: 100%;
          transition: ${theme.transitions.create(["all"])};
          justify-content: flex-start;
          font-size: ${theme.typography.pxToRem(13)};
          padding: 10ox;
          position: relative;
          gap:8px;

          .name-wrapper {
            display: block;
          }

          .MuiBadge-root {
            position: absolute;
            right: 10px;
            top: 11px;

            .MuiBadge-standard {
              background: ${theme.colors.primary.main};
              font-size: ${theme.typography.pxToRem(10)};
              font-weight: bold;
              text-transform: uppercase;
              color: ${theme.palette.primary.contrastText};
            }
          }
  
          .MuiSvgIcon-root {
            transition: ${theme.transitions.create(["color"])};
            font-size: ${theme.typography.pxToRem(22)};
            color: ${theme.sidebar.menuItemIconColor};
          }

          &.Mui-active{
            background-color: ${theme.sidebar.menuItemBgActive};
            color: ${theme.sidebar.menuItemColorActive};
            font-weight:bold;
            .MuiSvgIcon-root {
                color: ${theme.sidebar.menuItemIconColorActive};
            }
            &:hover { 
              background-color: ${theme.sidebar.menuItemBgActive};
              color: ${theme.sidebar.menuItemColorActive};

            .MuiSvgIcon-root {
                color: ${theme.sidebar.menuItemIconColorActive};
            }}
          }
       
          &:hover {
            background-color: ${theme.sidebar.menuItemBgHover};
            color: ${theme.sidebar.menuItemColorHover};

            .MuiSvgIcon-root {
                color: ${theme.sidebar.menuItemIconColorHover};
            }
          }
        }
      }
    }
`,
);

const renderSidebarMenuItems = ({ items, path }) => {
  const auth = useAuth();

  return (
    <SubMenuWrapper>
      <List component="div">
        {items
          .filter((item) => {
            if (!item.permission) {
              return true;
            }
            return auth.permissions.includes(item.permission);
          })
          .reduce((ev, item) => reduceChildRoutes({ ev, item, path }), [])}
      </List>
    </SubMenuWrapper>
  );
};

const reduceChildRoutes = ({ ev, path, item }) => {
  const key = uuidv4();

  const exactMatch = item.link
    ? !!matchPath(
        {
          path: item.link,
          end: true,
        },
        path,
      )
    : false;

  if (item.items) {
    const partialMatch = item.link
      ? !!matchPath(
          {
            path: item.link,
            end: false,
          },
          path,
        )
      : false;

    ev.push(
      <SidebarMenuItem
        key={key}
        active={partialMatch}
        open={partialMatch}
        name={item.name}
        icon={item.icon}
        link={item.link}
        badge={item.badge}
      >
        {renderSidebarMenuItems({
          path,
          items: item.items,
        })}
      </SidebarMenuItem>,
    );
  } else {
    ev.push(
      <SidebarMenuItem
        key={key}
        active={exactMatch}
        name={item.name}
        link={item.link}
        badge={item.badge}
        icon={item.icon}
      />,
    );
  }

  return ev;
};

function SidebarMenu() {
  const location = useLocation();

  return (
    <>
      {menuItems.map((section) => (
        <Fragment key={uuidv4()}>
          <MenuWrapper>
            <List component="div">
              {renderSidebarMenuItems({
                items: section.items,
                path: location.pathname,
              })}
            </List>
          </MenuWrapper>
          <DividerWrapper />
        </Fragment>
      ))}
    </>
  );
}

export default SidebarMenu;
